document.addEventListener('DOMContentLoaded', async () => {
	const canvas = document.querySelector('#dotlottie-canvas-hero')

	if (canvas) {
		// Start loading the hero animation
		const dotLottieHero = new DotLottie({
			loop: true,
			canvas: canvas,
			src: '/assets/lottie/thrive-locally-hero-' + window.season + '.lottie',
			renderConfig: {
				devicePixelRatio: 1,
				freezeOnOffscreen: true,
				autoResize: true,
			},
			layout: {
				fit: 'cover',
				align: [0.5, 0.5],
			},
		})

		// Once the hero animation has loaded, wait for the loader to complete a loop
		// dotLottieHero.addEventListener('load', async e => {
		// 	try {
		// 		await window.loaderAnimation
		// 	} catch (e) {
		// 		// Do nothing
		// 	}
		// 	window.controller.abort()
		// })

		// If the hero fails to load for some reason, fade out the loader anyway once the loop is complete
		// dotLottieHero.addEventListener('loadError', e => {
		// 	window.controller.abort()
		// })

		// Once a loop has been completed, fade the loader out and stop the animation
		await window.loaderAnimation
		dotLottieHero.play()
		// This is necessary because in Chrome on mobile, the freezeOnOffscreen option causes the animation to be frozen on page load
		// This ensures it unfreezes on page load to get started, but allows us to still use the freezeOnOffscreen option for better performance
		dotLottieHero.unfreeze()
	}
})
